import { createContext, useContext, ReactNode } from 'react'
import { BrandKit } from 'types'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'

interface SharedBrandKitState {
  brandKit?: BrandKit
  isLoading: boolean
}

const SharedBrandKitCtx = createContext<SharedBrandKitState | null>(null)

export const useSharedBrandKit = () => {
  const ctx = useContext(SharedBrandKitCtx)
  if (!ctx) throw new Error('useSharedBrandKit must be used within SharedBrandKitProvider')
  return ctx
}

export const SharedBrandKitProvider = ({ children, brandKitId }: { children: ReactNode; brandKitId?: number }) => {
  const { data: brandKitResponse, isLoading } = useBrandKit(brandKitId, {
    includeAllMediaFiles: true,
    enabled: !!brandKitId,
  })

  const value = {
    brandKit: brandKitResponse?.brand_kit,
    isLoading,
  }

  return <SharedBrandKitCtx.Provider value={value}>{children}</SharedBrandKitCtx.Provider>
}
